<template>
  <base-material-card
    color="primary"
    icon="mdi-file-compare"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Adicionar Relatório
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="titulo-caderno-servicos"
              label="Título"
              outlined
              :error-messages="errors"
              v-model="titulo"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              label="Selecione um Caderno Importado"
              :items="cadernosImportados"
              item-text="nome"
              item-value="id"
              v-model="cadernoSelecionado"
              dense
              outlined
            ></v-select>
          </validation-provider>
        </v-col>
      </v-row>
      
      <v-row align="center" no-gutters class="mx-4" id="periodo-lancamento-caderno-servicos">
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerLancInicio"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider 
                v-slot="{ errors }"
                rules="required|min:10"
              >
                <v-text-field
                  :error-messages="errors"
                  class="pt-0"
                  v-mask="'##/##/####'"
                  v-model="dataFormattedLancInicio"
                  label="Data Lançamento"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataLancInicio = parseDate(dataFormattedLancInicio);"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataLancInicio"
              @input="menuPickerLancInicio = false; dataFormattedLancInicio = formatDate(dataLancInicio);"
              locale="pt-br"
            />
          </v-menu>
        </v-col>
        <v-col class="text-center py-4" style="white-space: nowrap !important;" sm="1" cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
        </v-col>
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerLancFim"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider 
                v-slot="{ errors }" 
                rules="required|min:10"
              >
                <v-text-field
                  :error-messages="errors"
                  class="pt-0"
                  v-mask="'##/##/####'"
                  v-model="dataFormattedLancFim"
                  label="Data Lançamento"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataLancFim = parseDate(dataFormattedLancFim);"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataLancFim"
              @input="menuPickerLancFim = false; dataFormattedLancFim = formatDate(dataLancFim);"
              locale="pt-br"
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>

import dateFormatterMixins from '@/mixins/dateFormatterMixins';

export default {
  mixins: [dateFormatterMixins],

  props: {
    cadernosImportados: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      titulo: '',
      menuPickerLancInicio: false,
      menuPickerLancFim: false,
      cadernoSelecionado: null,
      dataFormattedLancInicio: '',
      dataLancInicio: '',
      dataFormattedLancFim: '',
      dataLancFim: ''
    };
  },

  methods: {
    exportData() {
      return {
        nome: this.titulo,
        data_lancamento_inicio: this.dataLancInicio,
        data_lancamento_fim: this.dataLancFim,
        caderno_servico_id: this.cadernoSelecionado
      }
    }
  }
};

</script>